'use client';

import dynamic from 'next/dynamic';

// that's a chunky boy
export const LottiePlayer = dynamic(() => import('./inner-lottie-player'), { ssr: false });
